module.exports = __webpack_public_path__ + "static/potvin-736212b00eecc8ab37a7d1d472f44444.jpg";